export const equalsAny = <T>(value: T, listOfValues: T[]): boolean =>
  listOfValues.some((item) => item === value);
